export default __webpack_public_path__ + "static/media/logo-banner.7cd1df98.png";